import { useEffect } from 'react';

import { useHistory, useLocation } from 'react-router-dom';
import useTimeout from '@pages/adminUsers/adminUsers/hooks/useTimeout';
import { useSelector } from 'react-redux';
import { getMfaPostSuccess } from '@selectors/mfa';
import usePrevious from 'lib/src/hooks/usePrevious';
import { LoginRedirectState } from '@pages/auth/login/LoginFormContainer';

const useMfaRedirect = () => {
    const history = useHistory();
    const timeout = useTimeout();
    const location = useLocation<LoginRedirectState>();
    const from = location?.state?.from;
    const postSuccess = useSelector(getMfaPostSuccess);

    let redirectURL = from?.pathname || '/';
    // stop potential redirect loop
    if (redirectURL.toLowerCase().includes('auth')) redirectURL = '/';

    const prevPostSuccess = usePrevious(postSuccess);
    useEffect(() => {
        if (!prevPostSuccess && postSuccess) {
            timeout(() => {
                history.push(redirectURL);
            }, 150);
        }
    }, [postSuccess, prevPostSuccess, history, redirectURL, from, timeout]);

    return redirectURL;
};

export default useMfaRedirect;
